import React, { Component } from 'react';
import { isEmpty } from 'lodash';

import { Box, Table, TableRow, TableBody, TableCell,  TableHead, Fab, IconButton} from '@mui/material';
import { AddRounded, DeleteRounded } from '@mui/icons-material';
import { grey, amber, red, green } from '@mui/material/colors';
import TableWithFilters from '../../common/TableWithFilters';
import EmployeeLoanDemandSingle from './EmployeeLoanDemandSingle';



class EquipDemandList extends Component {
    state = { 
        selected: {},
        openFilters: false,
        openDemand: false,
        singleDemand: {},
    }
    componentDidMount = async() => {
        // TO DO
        // FETCH USER LOAN LIST !OVER
        //
        // let list = await this.props.fetchUserLoans()
        // console.log('================EMPLOYEE EQUIPEMENT====================');
        // console.log({list});
        // console.log('====================================');
        if(isEmpty(this.props.LOAN_DEMANDS)){
            await this.props.fetchUserLoanDemands()
        }
    }
   
    getRowStyle = (params) => {
        const validate = params.demand_validate
        // console.log('====================================');
        // console.log({validate, params});
        // console.log('====================================');
        if (!validate) {
          return 'demand-waiting';
        }
        if (validate) {
          return 'demand-validate';
        }
        return '';
    };
    handleDelete = async (demandID) => {
        await this.props.deleteLoanDemand(demandID)
    }
    render() {
        const { LOAN_DEMANDS } = this.props;
        const {openDemand, singleDemand } = this.state;
        return (
            <Box>
                {openDemand && singleDemand && 
                    <EmployeeLoanDemandSingle
                        open={true}
                        handleCloseAll={() => this.setState({ openDemand: false, singleDemand: {} }) }
                        DEMAND={LOAN_DEMANDS[singleDemand.demand_loan_id]}
                        // handleOpenUpdate={ () => this.handleOpenUpdateFromSingle(user) } 
                        {...this.props}
                    />
                }
                <Box p={1}>
                    <TableWithFilters
                        internalId="demand_loan_id"
                        rows={Object.values(LOAN_DEMANDS)}
                        getRowStyle={this.getRowStyle}
                        // filterList={this.handleFilters}
                        columns={[
                            {
                                field: 'demand_creation_date',
                                headerName: "Date de Demande", 
                                // valueGetter: (params) => `${new Date(params.row.demand_creation_date).toLocaleDateString("fr-FR")}`,
                                renderCell: (params) => (
                                    <span>{
                                        new Date(params.row.demand_creation_date).getFullYear() > 1 ? 
                                        `${new Date(params.row.demand_creation_date).toLocaleDateString("fr-FR")}` : 
                                        "--"
                                    }
                                    </span>

                                ),
                                width: 150
                            },
                            {
                                field: 'demand_start_date',
                                headerName: "Date Début", 
                                // valueGetter: (params) => `${new Date(params.row.demand_start_date).toLocaleDateString("fr-FR")}`,
                                renderCell: (params) => (
                                    <span>{
                                        new Date(params.row.demand_start_date).getFullYear() > 1 ? 
                                        `${new Date(params.row.demand_start_date).toLocaleDateString("fr-FR")}` : 
                                        "--"
                                    }
                                    </span>

                                ),
                                width: 150
                            },
                            {
                                field: 'demand_end_date',
                                headerName: "Date Fin", 
                                // valueGetter: (params) => `${new Date(params.row.equipement_date_acquisition)}`,
                                renderCell: (params) => (
                                    <span>{
                                        new Date(params.row.demand_end_date).getFullYear() > 1 ? 
                                        `${new Date(params.row.demand_end_date).toLocaleDateString("fr-FR")}` : 
                                        "--"
                                    }
                                    </span>

                                ),
                                width: 150
                            },
                            {
                                field: 'demand_remarks',
                                headerName: "Usage prévu", 
                                valueGetter: (params) => `${params.row.demand_remarks}`,
                                width: 350
                            },
                            {
                                field: 'demand_status',
                                headerName: "Statut", 
                                valueGetter: (params) => `${params.row.demand_status}`,
                                width: 350
                            },
                            {
                                field: 'details',
                                headerName: 'Details',
                                sortable: false,
                                width: 100,
                                renderCell: (params) => (
                                    <IconButton 
                                        aria-controls={`option-menu${params.row.demand_loan_id}`} 
                                        aria-haspopup="true"
                                        onClick={() => this.setState({ openDemand: true, singleDemand: params.row}) }>
                                        <AddRounded />
                                    </IconButton>
                                )
                            },
                            {
                                field: 'supprimer',
                                headerName: 'Supprimer',
                                sortable: false,
                                width: 100,
                                renderCell: (params) => (
                                    (params.row.demand_status == "DEMAND_WAITING" || params.row.demand_status == "DEMAND_UPDATED") &&
                                    <IconButton 
                                        aria-controls={`option-menu${params.row.demand_loan_id}`} 
                                        aria-haspopup="true"
                                        onClick={() => this.handleDelete(params.row.demand_loan_id) }
                                        // onClick={() => this.setState({ openDemand: true, singleDemand: params.row}) }
                                        color="error"
                                    >
                                        <DeleteRounded />
                                    </IconButton>
                                )
                            },
                                // {
                                //     field: 'actions',
                                //     headerName: 'Actions',
                                //     sortable: false,
                                //     width: 100,
                                //     renderCell: (params) => (
                                //         // params.row.equipement_quantity == 1 ?
                                        
                                //         <>
                                //         <IconButton 
                                //             aria-controls={`option-menu${params.row.demand_loan_id}`} 
                                //             aria-haspopup="true"
                                //             onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : params.row.demand_loan_id}) }>
                                //             <MoreVertRounded />
                                //         </IconButton>

                                //         {/* <Menu
                                //             MenuListProps={{
                                //             'aria-labelledby': 'basic-button',
                                //             }}
                                //             id={`option-menu${params.row.equipement_id}`}
                                //             anchorEl={anchorEl}                                               
                                //             anchorOrigin={{
                                //                 vertical: 'bottom',
                                //                 horizontal: 'right',
                                //             }}
                                //             transformOrigin={{
                                //                 vertical: 'top',
                                //                 horizontal: 'right',
                                //             }}
                                //             open={ openMenu === params.row.equipement_id}
                                //             onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                                //         >
                                //             {!params.row.equipement_available && !params.row.no_loan &&
                                //                 <MenuItem onClick={() => this.props.handleOpenReturn(params.row) } >Restitution</MenuItem>    
                                //             }   
                                //             {params.row.equipement_available &&
                                //                 <>    
                                //                     <MenuItem onClick={() => this.props.handleOpenAttribute(params.row) } >Attribution</MenuItem>    
                                //                     <MenuItem onClick={() => this.handleOpenUpdate(params.row) } >Modifier</MenuItem>                
                                //                     <MenuItem onClick={() => this.handleOpenUpdate(params.row, "openUpdatePics") } >Modifier Photos</MenuItem>                
                                //                     <MenuItem 
                                //                         onClick={() => this.handleOpenUpdate(params.row, "openDelete") }
                                //                     >
                                //                         Supprimer
                                //                     </MenuItem>
                                //                 </>
                                //             }
                                            
                                //         </Menu> */}
                                //         </>
                                //     // :
                                //     //     ""
                                //     ),
                                // },
                        ]}
                    />
                
                </Box>
            </Box>                
        );
    }
}
export default EquipDemandList;

// function mapStateToProps(state){
//     return {
//         LOANS: state.loans.USER,
//     }
// }

// function mapDispatchToProps(dispatch){
//     return bindActionCreators({
//         fetchUserLoans,
//     }, dispatch)
// }

// export default connect(mapStateToProps, mapDispatchToProps)(EquipDemandList);